import axios from "axios";

const API_URL = "https://sharp-lamarr.180-179-213-167.plesk.page/api/";

// Configure axios instance with default headers
const apiClient = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

export const sendContactForm = (formData) => {
    console.log(formData);
    
    // Map formData keys to API parameter names
    const params = {
        UserName: formData.userName || '',
        Email: formData.email || '',
        MobileNo: formData.mobileNo || '',
        Questions: formData.questions || '',
        SubjectId: formData.subjectId || '',
        State: formData.state || '',
        City: formData.city || '',
        CheckInDate: formData.checkInDate || '',
        CheckOutDate: formData.checkOutDate || '',
    };

    return axios.get(
        `${API_URL}UserInfo/userpost`,
        {
            params: params,
            withCredentials: false, // don't send cookies or auth headers automatically
            headers: {
                'Content-Type': 'application/json'
            }
        }
    )
    .then(response => {
        console.log('Response:', response.data);
        return response.data;
    })
    .catch(error => {
        console.error('Error:', error);
        throw error;
    });
};
export const getSubjectOptions = async () => {
    try {
        const response = await apiClient.get(`${API_URL}UserInfo/types`);
        return response.data;
    } catch (error) {
        console.error("Error fetching subject options:", error);
        throw error;
    }
};

